import React from 'react';
import styled from 'styled-components';

interface SignInProps {
  onSignIn: () => void;
  onMsalSignIn: () => void;
}

const SignIn: React.FC<SignInProps> = ({ onSignIn, onMsalSignIn }) => {
  return (
    <Container>
      <LoginBox>
        <Title>NEPA Public Comment Agency Review (PCAR)</Title>
        <Divider label="SWCA Staff" />
        <Description>Sign in with your SWCA OneLogin account.</Description>
        <SignInButton onClick={onSignIn}>Sign In with OneLogin (SWCA)</SignInButton>
        <Divider label="Agency / External Users" />
        <Description>Sign in with your Microsoft account.</Description>
        <MicrosoftButton onClick={onMsalSignIn}>Sign In with Microsoft</MicrosoftButton>
      </LoginBox>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 20px;
`;

const LoginBox = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 400px;
  width: 100%;
  text-align: center;
`;

const Title = styled.h1`
  color: #194c66;
  font-size: 24px;
  margin-bottom: 16px;
  text-align: center;
`;

const Description = styled.p`
  color: #555;
  margin-bottom: 32px;
  line-height: 1.5;
`;

const SignInButton = styled.button`
  background-color: #194c66;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;

  &:hover {
    background-color: #315f94;
  }
`;

const MicrosoftButton = styled(SignInButton)`
  background-color: #2f6fbe;

  &:hover {
    background-color: #1e4f9c;
  }
`;

const DividerWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0 8px;
  gap: 8px;
`;

const DividerLine = styled.hr`
  flex: 1;
  border: none;
  border-top: 1px solid #ddd;
  margin: 0;
`;

const DividerLabel = styled.span`
  font-size: 12px;
  color: #888;
  white-space: nowrap;
`;

const Divider: React.FC<{ label: string }> = ({ label }) => (
  <DividerWrapper>
    <DividerLine />
    <DividerLabel>{label}</DividerLabel>
    <DividerLine />
  </DividerWrapper>
);

export default SignIn;